import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { LocaStockService } from '../../../service/loca-stock/loca-stock.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa6040.component.html',
  styleUrls: ['wa6040.component.css']
})
export class Wa6040Component implements OnInit {
  public componentTitle = 'WA6040:品質切替';

  // Common
  private parentWindowKey = 'parentWindow';
  private parentWindowValue = 'wa6040';
  private sessionLocaStockPSelectedKey = 'locastockpSelected';
  private sessionLocaStockPKey = 'rowLocastockp';
  private sessionLocaSelectedKey = 'locaSelected';
  private sessionLocaKey = 'rowLoca';
  private sessionLoginResultKey = 'loginResult';
  // Specific
  private sessionSrcLocaStockKey = 'wa6040-SrcLocaStock';
  private sessionDestLocaKey = 'wa6040-DestLoca';
  private sessionUpdPcsKey = 'wa6040-UpdPcs';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // Define each input element (initial value and validation rule)
  public locaCd = new FormControl('', [Validators.required]);
  public destlocaCd = new FormControl('', [Validators.required]);
  public updstockNr = new FormControl('', [Validators.required, Validators.min(1)]);
  // build FormGroup
  myForm = this.builder.group({
    locaCd: this.locaCd,
    destlocaCd: this.destlocaCd,
    updstockNr: this.updstockNr
  });

  // other variables
  public locastockpId: number;
  public locaId: number;
  public locaTx: string;
  public itemId: number;
  public itemCd: string;
  public itemTx: string;
  public lotTx: string;
  public uselimitDt: string;
  public stockDt: string;
  public typestockCd: string;
  public typestockTx: string;
  public typecoldTx: string;
  public stockNr: number;
  public destlocaId: number;
  public destlocaTx: string;
  public desttypestockCd: string;
  public desttypestockTx: string;
  public desttypecoldTx: string;

  private errorInfo = '';
  constructor(
    private router: Router,
    private builder: FormBuilder,
    private locaStockService: LocaStockService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngOnInit(): void {
    sessionStorage.removeItem(this.parentWindowKey);
    // src
    const locastockpSelected = sessionStorage.getItem(this.sessionLocaStockPSelectedKey);
    if (locastockpSelected === '1') {
      sessionStorage.setItem(this.sessionSrcLocaStockKey, sessionStorage.getItem(this.sessionLocaStockPKey));
    }
    sessionStorage.removeItem(this.sessionLocaStockPSelectedKey);
    sessionStorage.removeItem(this.sessionLocaStockPKey);
    const locastockp: object = JSON.parse(sessionStorage.getItem(this.sessionSrcLocaStockKey));
    if (locastockp !== null) {
      this.locastockpId = locastockp['locastockpId'];
      this.locaId = locastockp['locaId'];
      this.locaCd.setValue(locastockp['locaCd']);
      this.locaTx = locastockp['locaTx'];
      this.itemId = locastockp['itemId'];
      this.itemCd = locastockp['itemCd'];
      this.itemTx = locastockp['itemTx'];
      this.lotTx = locastockp['lotTx'];
      this.uselimitDt = locastockp['uselimitDt'];
      this.stockDt = locastockp['stockDt'];
      this.typestockCd = locastockp['typestockCd'];
      this.typestockTx = locastockp['typestockTx'];
      this.typecoldTx = locastockp['typecoldTx'];
      this.stockNr = locastockp['stockNr'];
    }
    // dest
    const locaSelected = sessionStorage.getItem(this.sessionLocaSelectedKey);
    if (locaSelected === '1') {
      sessionStorage.setItem(this.sessionDestLocaKey, sessionStorage.getItem(this.sessionLocaKey));
    }
    sessionStorage.removeItem(this.sessionLocaSelectedKey);
    sessionStorage.removeItem(this.sessionLocaKey);
    const loca: object = JSON.parse(sessionStorage.getItem(this.sessionDestLocaKey));
    if (loca !== null) {
      this.destlocaId = loca['locaId'];
      this.destlocaCd.setValue(loca['locaCd']);
      this.destlocaTx = loca['locaTx'];
      this.desttypestockCd = loca['typestockCd'];
      this.desttypestockTx = loca['typestockTx'];
      this.desttypecoldTx = loca['typecoldTx'];
      this.updstockNr.setValue(loca['stockNr']);
    }
    // upd pcs
    if (sessionStorage.getItem(this.sessionUpdPcsKey) !== null && sessionStorage.getItem(this.sessionUpdPcsKey).match(/d+/)) {
      this.updstockNr.setValue(sessionStorage.getItem(this.sessionUpdPcsKey));
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  searchSrcLocaStock() {
    sessionStorage.setItem(this.sessionUpdPcsKey, this.updstockNr.value);
    sessionStorage.setItem(this.parentWindowKey, this.parentWindowValue);
    this.router.navigate(['wa0040']);
  }

  searchDestLoca() {
    sessionStorage.setItem(this.sessionUpdPcsKey, this.updstockNr.value);
    sessionStorage.setItem(this.parentWindowKey, this.parentWindowValue);
    this.router.navigate(['wa0030']);
  }

  execute() {
    if (this.stockNr < this.updstockNr.value) {
      this.errorInfo = '在庫数を超える品質切替数を指定することはできません';
      return;
    }
    this.working = true;
    this.locaStockService
      .updTypeStock(this.locastockpId, this.updstockNr.value, this.destlocaId, '', 'wa6040')
      .then(outputJson => {
        this.working = false;
        sessionStorage.removeItem(this.parentWindowKey);
        sessionStorage.removeItem(this.sessionLocaStockPSelectedKey);
        sessionStorage.removeItem(this.sessionLocaStockPKey);
        sessionStorage.removeItem(this.sessionLocaSelectedKey);
        sessionStorage.removeItem(this.sessionLocaKey);
        sessionStorage.removeItem(this.sessionSrcLocaStockKey);
        sessionStorage.removeItem(this.sessionDestLocaKey);
        sessionStorage.removeItem(this.sessionUpdPcsKey);
        this.router.navigate([
          JSON.parse(sessionStorage.getItem(this.sessionLoginResultKey)).user.roleId === 3  
          ? 'wa0003' : 'wa0002']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    sessionStorage.removeItem(this.parentWindowKey);
    sessionStorage.removeItem(this.sessionLocaStockPSelectedKey);
    sessionStorage.removeItem(this.sessionLocaStockPKey);
    sessionStorage.removeItem(this.sessionLocaSelectedKey);
    sessionStorage.removeItem(this.sessionLocaKey);
    sessionStorage.removeItem(this.sessionSrcLocaStockKey);
    sessionStorage.removeItem(this.sessionDestLocaKey);
    sessionStorage.removeItem(this.sessionUpdPcsKey);
    this.router.navigate([
      JSON.parse(sessionStorage.getItem(this.sessionLoginResultKey)).user.roleId === 3  
      ? 'wa0003' : 'wa0002']);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6040/wa6040.component.ts